import React from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Badge,
  Input,
  Button,
} from "reactstrap";
import Select from "react-select";
import { useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function GroupCard({
  group,
  setNewChanges,
  newChanges,
  currentSchools,
  setCurrentSchools,
  allSchools,
  changedNames,
  setChangedNames,
  setPromptForDelete,
}) {
  const intl = useIntl();
  const handleRemoveSchoolFromGroup = (schoolId) => {
    let tempSchools = [...currentSchools];
    let currentSchool = tempSchools.find((sch) => sch.id === schoolId);
    if (currentSchool.isPendingAdded) {
      setNewChanges(
        newChanges.filter((school) => school.schoolId !== schoolId)
      );
      currentSchool.group = null;
    } else {
      currentSchool.group = null;
      setNewChanges([...newChanges, { schoolId: schoolId, groupId: null }]);
    }
    setCurrentSchools(tempSchools);
  };

  const handleAddSchoolsToGroup = (school) => {
    let tempSchools = [...currentSchools];
    let currentSchool = tempSchools.find((sch) => sch.id === school.value.id);
    currentSchool.group = group;
    currentSchool.isPendingAdded = true;
    setCurrentSchools(tempSchools);
    if (newChanges.some((sch) => sch.schoolId === school.value.id)) {
      let currentSchoolChanges = newChanges.find(
        (sch) => sch.schoolId === school.value.id
      );
      currentSchoolChanges.group = group.id;
    } else {
      setNewChanges([
        ...newChanges,
        { schoolId: school.value.id, group: group.id },
      ]);
    }
  };

  const handleSetNewName = (newName) => {
    if (newName.trim() !== "") {
      if (changedNames.some((gr) => gr.id === group.id)) {
        const tempChangesNames = JSON.parse(JSON.stringify(changedNames));
        tempChangesNames.find((tcn) => tcn.id === group.id).name = newName;
        setChangedNames(tempChangesNames);
      } else {
        setChangedNames([
          ...changedNames,
          { id: group.id, name: newName.trim() },
        ]);
      }
    }
  };

  return (
    <Card className="mx-3 overflow-visible">
      <CardHeader>
        <Row>
          <Col lg="1" style={{ alignContent: "space-evenly" }}>
            <Button
              outline
              color="danger"
              size="sm"
              onClick={() => setPromptForDelete(group)}
            >
              <FontAwesomeIcon icon="trash" />
            </Button>
          </Col>
          <Col>
            <Input
              defaultValue={group.name}
              type="text"
              onChange={(data) => handleSetNewName(data.target.value)}
            />
          </Col>
          <Col>
            <Select
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              menuPortalTarget={document.body}
              placeholder={intl.formatMessage({ id: "AddToGroup" })}
              onChange={(selected) => handleAddSchoolsToGroup(selected)}
              options={allSchools
                .filter((school) => school.group === null)
                .map((option) => ({
                  label: option.name,
                  value: option,
                  clearableValue: true,
                }))}
            />
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        {currentSchools
          .filter((school) => school.group !== null)
          .filter((schoolWithGroup) => schoolWithGroup.group.id === group.id)
          .map((sch) => {
            return (
              <Badge className="mx-1 rounded" color="primary" key={sch.id}>
                <span>{sch.name}</span>
                <span
                  className="ps-1 text-danger"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleRemoveSchoolFromGroup(sch.id)}
                >
                  <FontAwesomeIcon icon="trash" />
                </span>
              </Badge>
            );
          })}
      </CardBody>
    </Card>
  );
}
